import { Component, Input } from '@angular/core';

import { AuthService } from 'src/app/services/auth.service';
import { Permission } from 'src/app/constants/permission.constant';

@Component({
  standalone: false,
  selector: 'app-product-status-cell',
  templateUrl: './product-status-cell.component.html',
})
export class ProductStatusCellComponent {
  @Input() product!: {
    releasedInCollection: boolean;
    approvedOutputAssetCount: number;
    expectedOutputAssetCount: number;
  };

  readonly Permission = Permission;

  constructor(public readonly authService: AuthService) {}
}
